Object.defineProperty(exports, "__esModule", { value: true });
var Sequence_1 = require("./Sequence");
var MapNotNull = /** @class */ (function () {
    function MapNotNull() {
    }
    /**
     * Transforms each element into another value by applying the given `transform` function and returns a new sequence.
     * Transformations into `null` values are discarded.
     *
     * @param {(value: T) => R} transform
     * @returns {Sequence<R>}
     */
    MapNotNull.prototype.mapNotNull = function (transform) {
        return this.flatMap(function (value) {
            var item = transform(value);
            return item !== null
                ? Sequence_1.sequenceOf(item)
                : Sequence_1.emptySequence();
        });
    };
    return MapNotNull;
}());
exports.MapNotNull = MapNotNull;
//# sourceMappingURL=mapNotNull.js.map